import React, { useState, useRef } from 'react';
import { useCursor } from '../context/CursorContext';

export const TiltCard = (props) => {
  const { children, className, cursorLabel, glowColor } = props;
  const cls = className || '';
  const label = cursorLabel || '';
  const glow = glowColor || 'rgba(34, 197, 94, 0.15)';

  const cardRef = useRef(null);
  const cursor = useCursor();
  const [tilt, setTilt] = useState('');
  const [gx, setGx] = useState(50);
  const [gy, setGy] = useState(50);
  const [active, setActive] = useState(false);

  function onMove(e) {
    var el = cardRef.current;
    if (!el) return;
    var rect = el.getBoundingClientRect();
    var x = (e.clientX - rect.left) / rect.width;
    var y = (e.clientY - rect.top) / rect.height;
    var rx = (y - 0.5) * -8;
    var ry = (x - 0.5) * 8;
    setTilt('perspective(800px) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) scale3d(1.02,1.02,1.02)');
    setGx(x * 100);
    setGy(y * 100);
    setActive(true);
  }

  function onLeave() {
    setTilt('');
    setGx(50);
    setGy(50);
    setActive(false);
    if (label) cursor.setLabel('');
  }

  function onEnter() {
    if (label) cursor.setLabel(label);
  }

  var glowBg = 'radial-gradient(400px circle at ' + gx + '% ' + gy + '%, ' + glow + ', transparent 70%)';

  return (
    <div
      ref={cardRef}
      className={'relative overflow-hidden transition-transform duration-200 ease-out ' + cls}
      style={{ transform: tilt }}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      onMouseEnter={onEnter}
    >
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: glowBg, opacity: active ? 0.6 : 0, transition: 'opacity 0.3s' }}
      />
      <div className="relative z-10">{children}</div>
    </div>
  );
};
